export const LINE_COLORS = [
  '#610bef',
  '#00bbff',
  '#12b76a',
  '#e61b00',
  '#ffccc1',
  '#ff00f1',
  '#00f2f1',
  '#008888',
  '#550911',
  '#0000ff',
];

export type RangePeriod = 'LastSevenDays' | 'LastThirtyDays' | 'AllTime';
export const rangePeriodOptions: {
  label: string;
  value: RangePeriod;
}[] = [
  {
    label: '7 days',
    value: 'LastSevenDays',
  },
  {
    label: '30 days',
    value: 'LastThirtyDays',
  },
  {
    label: 'All time',
    value: 'AllTime',
  },
];
